import { registerElement } from '@bcf2-shared-pkg-v1/ui/shared/classes/bcf-lit-element';
import { RouteConfig } from '@tmf-shared-platform/router/internal';
import { html } from 'lit';

export function appRoutes(langs: string[]): RouteConfig[] {
  return [
    {
      path: '/',
      render: () =>
        html`<bcf2-cs-ksm-default-lang-redirector-smart
          .availableLangs="${langs}"
        ></bcf2-cs-ksm-default-lang-redirector-smart>`,
      enter: async (): Promise<boolean> => {
        registerElement(
          (
            await import('@bcf2-v1-ui-others-components-casino-kingspin-mobile/default-lang-redirector-smart/default-lang-redirector-smart.element')
          ).DefaultLangRedirectorSmartElement
        );
        return true;
      }
    },
    ...langs.map(
      (lang: string) =>
        ({
          path: `/${lang}{/*}?`,
          render: () => html`<bcflit-sb-tkm-lang-route .appLang="${lang}"></bcflit-sb-tkm-lang-route>`,
          enter: async () => {
            registerElement((await import('./../../mobile/app/lang-route/lang-route.element')).LangRouteElement);
            return true;
          },
          data: {
            routeLang: lang
          }
        }) as RouteConfig
    )
  ];
}
